import React from 'react';

const AracCuzdaniTerms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Kullanım Koşulları</h1>
      <p className="text-center text-gray-600 mb-4">Son Güncelleme: Ağustos 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          Bu Kullanım Koşulları, Araç Cüzdanı ("Uygulama") uygulamasını kullanımınızı düzenler.
          Uygulamayı indirerek veya kullanarak bu koşulları kabul etmiş sayılırsınız.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Hizmet Tanımı</h2>
        <p>
          Araç Cüzdanı, kullanıcıların araçlarına ait yakıt, bakım, sigorta, vergi ve benzeri
          masrafları kaydetmelerine ve takip etmelerine olanak tanıyan bir araç masraf takip uygulamasıdır.
          Uygulama iOS ve Android platformlarında ücretsiz olarak sunulmaktadır.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Ücretlendirme</h2>
        <p>
          Uygulama şu anda tamamen ücretsizdir ve herhangi bir uygulama içi satın alma içermez.
          Geliştirici, ilerleyen dönemlerde ek özellikler, abonelik sistemleri veya ücretli planlar
          sunma hakkını saklı tutar. Böyle bir değişiklik olması durumunda kullanıcılar önceden
          bilgilendirilecek ve mevcut ücretsiz kullanım hakları korunacaktır.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Kullanım Kuralları</h2>
        <p>
          Uygulamayı kullanırken aşağıdaki kurallara uymayı kabul edersiniz:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Uygulamayı yalnızca yasal amaçlarla kullanmak</li>
          <li>Başkalarının haklarını ihlal etmemek</li>
          <li>Uygulamanın güvenliğini tehlikeye atacak eylemlerden kaçınmak</li>
          <li>Uygulamayı tersine mühendislik yapmamak veya kaynak kodunu çözmeye çalışmamak</li>
          <li>Uygulamanın altyapısına zarar verecek otomatik sorgu veya kötüye kullanımdan kaçınmak</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">4. Fikri Mülkiyet</h2>
        <p>
          Uygulama ve içeriği (tasarım, kod, grafikler, logolar) N1İnovasyon'a aittir ve telif hakkı ile korunmaktadır.
          Uygulamayı kullanma hakkı size verilmiştir ancak mülkiyet hakkı devredilmemiştir.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Veri ve Gizlilik</h2>
        <p>
          Uygulama kişisel veri toplamaz. Girdiğiniz araç ve masraf kayıtları Google Firebase
          altyapısında güvenli biçimde saklanır. Detaylı bilgi için lütfen{' '}
          <a href="/privacy/araccuzdani" className="text-blue-600 hover:text-blue-800">
            Gizlilik Politikamızı
          </a>{' '}
          inceleyin.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Sorumluluk Sınırlaması</h2>
        <p>
          Uygulama "olduğu gibi" sunulmaktadır. N1İnovasyon, uygulamanın kesintisiz veya hatasız
          çalışacağını garanti etmez. Veri kaybı veya dolaylı zararlardan N1İnovasyon sorumlu tutulamaz.
        </p>
        <p>
          Uygulamada gösterilen masraf özetleri ve istatistikler yalnızca bilgilendirme amaçlıdır;
          mali, hukuki veya teknik danışmanlık niteliği taşımaz. Kullanıcı, girdiği verilerin
          doğruluğundan ve yedeklenmesinden kendisi sorumludur.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Hesap ve Verilerin Sonlandırılması</h2>
        <p>
          Kullanım koşullarını ihlal etmeniz durumunda uygulamaya erişiminiz önceden bildirim
          yapılmaksızın askıya alınabilir. Verilerinizi istediğiniz zaman uygulama içinden
          veya bizimle iletişime geçerek silebilirsiniz.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Değişiklikler</h2>
        <p>
          Bu kullanım koşulları zaman zaman güncellenebilir.
          Önemli değişiklikler uygulama içinden bildirilecektir.
          Değişikliklerden sonra uygulamayı kullanmaya devam etmeniz, yeni koşulları kabul ettiğiniz anlamına gelir.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Uygulanacak Hukuk</h2>
        <p>
          Bu koşullar Türkiye Cumhuriyeti kanunlarına tabidir.
          Uyuşmazlıkların çözümünde Antalya Mahkemeleri ve İcra Daireleri yetkilidir.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. İletişim</h2>
        <p>
          Kullanım koşulları hakkında sorularınız için bizimle iletişime geçebilirsiniz:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a>
        </p>

        <div className="mt-12 p-4 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            Bu uygulamayı kullanarak yukarıdaki koşulları okuduğunuzu ve kabul ettiğinizi onaylarsınız.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AracCuzdaniTerms;
